module.exports = __webpack_public_path__ + "img/gazoukensa.f296f436.png";